import { React, useState } from "react";
// import  useState  from "react";
import Mansix1 from "../../Images/Man(6)1.png";
import Mansix2 from "../../Images/Man(6)2.png";
import Mansix3 from "../../Images/Man(6)3.png";
// import Mantwo4 from "../../Images/Man(2)4.png";
import buttonImage from "../../Images/button-image.png";
// import SmallImg4 from "../../Images/woman-img-4.jpg";
// import DetailImage from "../../Images/woman-img-2.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Manimgsix() {
  const [selectedImage, setSelectedImage] = useState(Mansix1);
  const handleImageClick = (image) => {
    setSelectedImage(image);
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="row reverse-col">
            <div className="col-md-3  "></div>

            <div className="col-md-2 col-xs-12 ">
              <div className="row">
                <div className="col-md-12 col-4 col-sm-4 col-xs-4">
                  <div
                    className={` res-top-mar ${
                      selectedImage === Mansix1 ? "selected-image" : ""
                    }`}
                  >
                    <LazyLoadImage
                      effect="blur"
                      onClick={() => handleImageClick(Mansix1)}
                      style={{ cursor: "pointer" }}
                      className="img-fluid"
                      src={Mansix1}
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-md-12 mar-top col-4 col-sm-4 col-xs-4">
                  <div
                    className={` res-top-mar ${
                      selectedImage === Mansix2 ? "selected-image" : ""
                    }`}
                  >
                    <LazyLoadImage
                      effect="blur"
                      onClick={() => handleImageClick(Mansix2)}
                      style={{ cursor: "pointer" }}
                      className="img-fluid"
                      src={Mansix2}
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-md-12 mar-top col-4 col-sm-4 col-xs-4">
                  <div
                    className={` res-top-mar ${
                      selectedImage === Mansix3 ? "selected-image" : ""
                    }`}
                  >
                    <LazyLoadImage
                      effect="blur"
                      onClick={() => handleImageClick(Mansix3)}
                      style={{ cursor: "pointer" }}
                      className="img-fluid"
                      src={Mansix3}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-xs-12 ">
              <LazyLoadImage
                effect="blur"
                className=" detail-image"
                src={selectedImage}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="col-md-5 detail-margn-left">
          <div className="res-images">
            <div className="image-container">
              <h1 className="Cormorant-font fw-bold responsive-one-rem">
                Modern Majestic Dark Suit
              </h1>
              <h5 className=" ">BLD24FT037-SML-MNT</h5>
              {/* <div className=" my-3">
                <button
                  type="button"
                  className="px-4 py-1 btn rounded-0   "
                  style={{ border: "1px solid black" }}
                >
                  <span className="me-2">
                    <LazyLoadImage effect="blur" src={buttonImage} alt="" />
                  </span>
                  <span>Size Chart</span>
                </button>
              </div> */}
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Fit type:</span>
                <span className=""> Slim Fit</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Design details:</span>
                <span>
                  {" "}
                  This contemporary two-button suit features notched lapels and
                  structured shoulders, offering a sleek silhouette. The suit is
                  complemented by a dark colored dress shirt and an elegant,
                  subtly textured tie, enhancing its sophisticated look.
                </span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Stretch:</span>
                <span> Minimal</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Transparency: </span>
                <span> Opaque</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Hand Feel:</span>
                <span> Smooth with a refined texture</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Lining:</span>
                <span> Full satin lining for superior comfort and fit</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Material: </span>
                <span> Premium wool blend for durability and comfort</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Size:</span>
                <span> The model is 164cm/5'4" and wears a size MEDIUM</span>
              </div>
              <div className="py-1 Cormorant-font fit-font-family">
                <span className="fw-bold ">Occasion:</span>
                <span> Formal Events, Business Meetings, or Weddings</span>
              </div>
              <div className="py-4 Cormorant-font  note-bg">
                <span className="fw-bold ">Note:</span>
                <span>
                  {" "}
                  The actual color of the product may vary slightly from the
                  image.
                </span>
              </div>
            </div>
            <div className="text-container">
              {/* col-md-3  col-xs-3 col-sm-3 */}
              {/* <div className="d-flex">
                <div
                  className={`mx-2 res-top-mar ${
                    selectedImage === Mansix1 ? "selected-image" : ""
                  }`}
                >
                  <LazyLoadImage effect="blur"
                    onClick={() => handleImageClick(Mansix1)}
                    style={{ cursor: "pointer" }}
                    className="img-fluid"
                    src={Mansix1}
                    alt=""
                  />
                </div>
                <div
                  className={`mx-2 res-top-mar ${
                    selectedImage === Mansix2 ? "selected-image" : ""
                  }`}
                >
                  <LazyLoadImage effect="blur"
                    onClick={() => handleImageClick(Mansix2)}
                    style={{ cursor: "pointer" }}
                    className="img-fluid"
                    src={Mansix2}
                    alt=""
                  />
                </div>
                <div
                  className={`mx-2 res-top-mar ${
                    selectedImage === Mansix3 ? "selected-image" : ""
                  }`}
                >
                  <LazyLoadImage effect="blur"
                    onClick={() => handleImageClick(Mansix3)}
                    style={{ cursor: "pointer" }}
                    className="img-fluid"
                    src={Mansix3}
                    alt=""
                  />
                </div>
             
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Manimgsix;
